export default __webpack_public_path__ + "static/media/spiralBg.edbd8b57.svg";